import {getValidQuantity} from "./getValidQuantity";

export const isValidQuantity = (localProxyType, quantity) => {
  const validQuantity = getValidQuantity(localProxyType, quantity);
  
  return validQuantity === quantity;
};
